// 完整應用程式測試
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import AppLayout from '@/AppLayout'
import { useI18n } from '@/hooks'
import { Footer, MainNavBar, TopNav } from '@/components/layouts'
import { ProductGallery, CoreValuesSection, BrandStory, ProductShowcase } from '@/components/sections'
import { ShopPage, AboutPage, LearnPage, GoogleTestPage, ProductDetailPage, CartPage, ProfilePage } from '@/components/pages'
import { getSeoContent } from '@/content/siteContent'
import { usePageMetadata } from '@/seo/usePageMetadata'

// 首頁組件
const HomePage = () => {
  const { lang, locale } = useI18n()
  const seo = getSeoContent(lang).home

  usePageMetadata({
    title: seo.title,
    description: seo.description,
    path: '/',
    locale,
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'CloutySpace',
        url: window.location.origin,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'CloutySpace',
        url: window.location.origin,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${window.location.origin}/shop?search={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  })

  return (
    <main className="pt-14">
      <h1 className="sr-only">CloutySpace</h1>
      <ProductShowcase lang={lang} />
      <ProductGallery lang={lang} />
      <CoreValuesSection lang={lang} />
      <BrandStory lang={lang} />
    </main>
  )
}

function App() {
  return (
    <Router>
      <AppLayout>
        <TopNav />
        <MainNavBar />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/:productId" element={<ProductDetailPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/learn" element={<LearnPage />} />
          <Route path="/test-google" element={<GoogleTestPage />} />
          <Route path="/account" element={<ProfilePage />} />
        </Routes>

        <Footer />
      </AppLayout>
    </Router>
  )
}

export default App
